import { VendorResponse } from "./vendor.model";
import { WarehouseResponse } from "./warehouse.model";

export class PurchaseResponse {
	accountingDate: number;
	balance:number;
	cancelled: boolean;
	cancelledDescription: string;
	company: number;
	creationDate: number;
	currency: number;
	date: any;
	description: string;
	discount: number;
	exchangeRate: number;
	hasExemption: any;
	hasISR: boolean;
	hasIVA: boolean;
	id: number;
	inventoryItem: number;
	invoice: boolean;
	lot: any;
	number: string;
	provider: number;
	providerData: VendorResponse;
	provisionalBalance: any;
	series: string;
	taxPercentage: number;
	totalCost: number;
	totalTaxes: number;
	extraTax: number;
	user: number;
	warehouse: number;
	warehouseData: WarehouseResponse;
	isNcre: boolean = false; // Este es solo para uso del front
	constructor(){

	}
}


export class PurchaseSeriesRequest {
	providerInvoice: number;
	warehouseId: number;
	productId: number;
	dataSeries: SeriesRequest[] = [];
}

export class SeriesRequest {
	series: string;
	dataSeries: SeriesResponse;
}

export class SeriesResponse {
	id: number;
	idProduct: number;
	seriesProduct: string;
	company: number;
	warehouse: number;
	clientInvoice: number;
	providerInvoice: number;
	dateAssociated: number;
}

export interface PurchaseVirtualResponse {
  accountingDate: number;
	balance:number;
	cancelled: boolean;
	cancelledDescription: string;
	company: number;
	creationDate: number;
	currency: number;
	date: any;
	description: string;
	discount: number;
	exchangeRate: number;
	hasExemption: any;
	hasISR: boolean;
	hasIVA: boolean;
	id: number;
	inventoryItem: number;
	invoice: boolean;
	lot: any;
	number: string;
	provider: number;
	providerData: VendorResponse;
	provisionalBalance: any;
	series: string;
	taxPercentage: number;
	totalCost: number;
	totalTaxes: number;
	extraTax: number;
	user: number;
	warehouse: number;
	warehouseData: WarehouseResponse;
	isNcre: boolean;
}

export interface PurchaseVirtualDetailResponse {
	id: number;
	productId: number;
	productName: string;
	quantity: number;
	price: number;
	batch: string;
	virtualActive: boolean;
	providerInvoiceVirtualId: number;
}
